
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/charity",
      function () {
        return require("private-next-pages/article/charity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/charity"])
      });
    }
  